import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class UploadImgService {
  private imageFileSubject: Subject<File> = new Subject<File>();
  public imageFile$ = this.imageFileSubject.asObservable();

  sendImage(file: File): void {
    this.imageFileSubject.next(file);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/upload-img/upload-img.service.ts